<template>
<div>
  <div v-if="detailTop && detailTop.title && detailBottom && detailBottom.length && steps">
  <div class="profile-intro">

      <img class="profile-img" :src="detailTop.picture || '/img/user.jpg'">

      <div class="profile-info" style="flex:2">
          <!-- @if(detailTop.topSubtitle) -->
          <p v-if="detailTop.topSubtitle" class="mb-2">{{detailTop.topSubtitle}}</p>
          <!-- @endif -->
          <!-- @if(detailTop.title) -->
          <h4 v-if="detailTop.title" class="mb-1">{{detailTop.title}}</h4>
          <!-- @endif -->
          <p v-if="detailTop.subtitle" class="mb-2">{{detailTop.subtitle}}</p>
          <!-- @endif -->
          <!-- @if(detailTop.items && detailTop.items.length ) -->
          <div v-if="detailTop.items && detailTop.items.length" class="profile-contact"  >
              <!-- @each(item in detailTop.items) -->
              <div v-for="item in detailTop.items" class="item" v-bind:key="item.content">
                  <i class="material-symbols-outlined">{{item.icon}}</i>
                  <span>{{item.content && item.content != null && item.content != 'null' ?item.content : 'Tidak Ada' }}</span>
              </div>
              <!-- @endeach -->
          </div>
          <!-- @endif -->

      </div>
      <div v-if="detailTop.topRight && detailTop.topRight.length" style="flex:2;" class="pr-3">
        <div v-for="(row,index) in detailTop.topRight" v-bind:key="row.key+Math.random(1023)" :class="'row '+(index?'mt-2':'')">
          <div  v-for="item in row.columns" :class="'px-1 col-md-'+(item.colnum || 12/row.columns.length)" v-bind:key="item.label+Math.random(1023)" >
              <div class="item mr-0" >
                <span>
                  <i class="material-symbols-outlined">{{item.icon}}</i>
                </span>
                <div>
                  <span class="item-label font-heading">{{item.label}}</span>
                  <h5 class="item-content font-body">{{item.content && item.content != null && item.content != 'null' ?item.content : 'Tidak Ada' }}</h5>
                </div><!---->
              </div>
          </div>
        </div>
      </div>
      <div v-else style="flex:1;" class="pr-4"></div>
  </div>
  <div :class="'profile-summary'">
      <!--@each(row in detailLeftTop)-->
      <div v-for="row in detailBottom" :class="'row summary-item'+(row.parentClass?row.parentClass:'')" v-bind:key="row.key">
          <!--@each(item in row.columns)-->
          <div v-for="item in row.columns" :class="'col-md-'+(row.colnum?12/row.colnum:(item.colwidth?item.colwidth:12))" v-bind:key="item.label+Math.random(1023)">
              <div :class="'item '+(item.className?item.className:'')">
                  <!--@if(item.type!='no-icon' && item.icon)-->
                  <span v-if="item.type!='no-icon' && item.icon">
                      <i :class="'material-symbols-outlined'">{{item.icon}}</i>
                  </span>
                  <!--@endif-->
                  <div>
                      <!--@if(item.label)-->
                      <span v-if="item.label" :class="'item-label '+(item.labelClass?item.labelClass:'')">{{item.label}}</span>
                      <!--@endif-->
                      <!--@if(item.content)-->
                      <div v-if="item.content" >
                          <a :href="item.content"  target="_blank" v-if="item.type=='image'">
                          <img :src="item.content" alt="" >
                          </a>
                          <a :href="item.content"  target="_blank" v-else-if="item.type=='file'">
                            Download File
                          </a>
                          <h5 v-else :class="'item-content'">
                              {{item.content && item.content != null && item.content != 'null' ?item.content : 'Tidak Ada' }}
                          </h5>
                      </div>
                      <div v-else>
                          <a :href="item.content"  target="_blank" v-if="item.type=='image'">
                            <img src="/img/no-picture.png" alt="" >
                          </a>
                          <h5 v-else-if="item.type=='file'" :class="'item-content'">
                              Tidak ada file
                          </h5>
                      </div>
                      <!--@endif-->
                  </div>
                  <!--@if(item.action)-->
                  <router-link v-if="item.action" :class="'btn btn-sm btn-with-icon-right btn-outline-secondary float-right ml-3'" :to="item.action.link" target="_blank">{{item.action.label}}<i :class="'material-symbols-outlined'">arrow_forward</i></router-link>
                  <!--@endif-->
              </div>
          </div>
          <!--@endeach-->
      </div>
      <!--@endeach-->
      <!--@each(input in detailLeftBottom)-->
      <!--@endeach-->
  </div>
  <Steps :steps="steps" v-if="steps && steps.length"/>
  </div>
  <Loading v-else/>
</div>
</template>

<script>
import Steps from './Steps';
import Loading from './Loading';
export default {
  name: 'IntroOperasi',
  components:{Steps,Loading},
  props: {
    detailTop:Object,
    detailBottom:Array,
    steps:Array
  }
}
</script>